/**
 * Purpose: Shared base configuration reused by all Angular frontend build variants (environment*.ts).
 *
 * Inherited by:
 * - environment.prod.ts  (Windows/Cloud environments)
 * - environment.linux.ts (Linux/Kubernetes build)
 * - environment.ts (local dev)
 *
 * Impact of changes: Changes here affect all build variants unless overridden in a specific environment*.ts file.
 */
export const baseEnvironment = {
  production: true,

  tracesCollectorUrl: `${globalThis.location.origin}/api/v1/traces`,
  logsCollectorUrl: `${globalThis.location.origin}/api/v1/logs`,

  frameApiBackendUrl: `${globalThis.location.origin}/api/v1/frame`,
  stationsBackendUrl: `${globalThis.location.origin}/api/v1/stations`,
  stationsFrontendUrl: `${globalThis.location.origin}/ui/stations`,
  stationsHubSignalRUrl: `${globalThis.location.origin}/hub/stationsHub`,

  signalsFrontendUrl: `${globalThis.location.origin}/ui/signals`,

  sharedsettingsFrontendUrl: `${globalThis.location.origin}/ui/sharedsettings`,

  protectionBackendServerAddress: `${globalThis.location.origin}/api/v1/protection`,
  protectionFrontendUrl: `${globalThis.location.origin}/ui/protection`,
  protectionHubSignalRUrl: `${globalThis.location.origin}/hub/protectionHub`,

  activitiesBackendUrl: `${globalThis.location.origin}/api/v1/activities`,
  activitiesFrontendUrl: `${globalThis.location.origin}/ui/activities`,

  communicationBackendUrl: `${globalThis.location.origin}/api/v1/communication`,
  communicationHubSignalRUrl: `${globalThis.location.origin}/hub/communicationHub`,
  communicationFrontendUrl: `${globalThis.location.origin}/ui/communication`,

  automationBackendUrl: `${globalThis.location.origin}/api/v1/automation`,

  inconsistenciesHubSignalRUrl: `${globalThis.location.origin}/hub/inconsistenciesHub`,
  inconsistenciesBackendUrl: `${globalThis.location.origin}/api/v1/inconsistencies`,
  inconsistenciesFrontendUrl: `${globalThis.location.origin}/ui/inconsistencies`,

  helpFrontendUrl: `${globalThis.location.origin}/ui/help`,

  systemConfiguratorBackendUrl: `${globalThis.location.origin}/api/v1/systemconfigurator`,
  revisionsBackendUrl: `${globalThis.location.origin}/api/v1/revisions`,
  revisionsFrontendUrl: `${globalThis.location.origin}/ui/revisions`,
  revisionsHubSignalRUrl: `${globalThis.location.origin}/hub/revisionsHub`,
};
